export const LBS_PAGE_SIZE = 10000;
